import { dash } from "sharekit";
import { component } from "./component.js";
/**
 * Decorator to define element and set styles.
 *
 * `option` will call {@link component}.
 *
 * @param name Proto name, wil call `GodownElement.godownConfig.tag(name)` to get the tag name.
 * @param option Omit `tagName` from {@link component} options.
 * @returns Decorator.
 */
export const godown = (name, option) => (constructor) => {
    name ||= dash(constructor.name);
    constructor.protoName = name;
    const tagName = constructor.godownConfig.tag(name);
    component({
        tagName,
        ...option,
    })(constructor);
};
//# sourceMappingURL=godown.js.map